import React from 'react';

export const BaseSystemPlugin = React.forwardRef<
    HTMLDivElement,
    {
        name?: string;
        children: React.ReactNode;
        style?: React.CSSProperties;
    }
>(({ name, children, style }, ref) => {
    return (
        <div ref={ref} className="editor-plugin editor-plugin-system" data-plugin={name} style={style}>
            {children}
        </div>
    );
});

BaseSystemPlugin.displayName = 'BaseSystemPlugin';
